import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class BaseApiUrl {
	public static Users = environment.SharedServices.Users;
	public static Dreams = environment.Dexter.Dreams;
	public static Targeting = environment.Targeting;
}
